import React, { useState } from "react";
import { motion } from "framer-motion";
import { toast } from "react-toastify";
import api from "../utils/api";

const createInitialFormData = () => ({
  name: "",
  email: "",
  subject: "",
  message: "",
  website: "",
  formStartedAt: Date.now(),
});

const Contact = () => {
  const [formData, setFormData] = useState(createInitialFormData);
  const [loading, setLoading] = useState(false);

  const updateField = (field, value) => {
    setFormData((current) => ({ ...current, [field]: value }));
  };

  const handleSubmit = async (e) => {
    e.preventDefault();
    setLoading(true);

    try {
      const response = await api.post("/contact", formData);
      toast.success(response.data.message || "Message sent! We'll get back to you soon.");
      setFormData(createInitialFormData());
    } catch (error) {
      console.error("Error sending message:", error);
      toast.error(error.response?.data?.error || "Failed to send message. Please try again.");
    } finally {
      setLoading(false);
    }
  };

  return (
    <div className="container mx-auto px-4 py-12 sm:py-16">
      <motion.div initial={{ opacity: 0, y: 20 }} animate={{ opacity: 1, y: 0 }} className="max-w-2xl mx-auto">
        <h1 className="heading-metallic mb-4 text-center text-3xl sm:text-4xl">Contact Us</h1>
        <p className="text-gray-400 text-center mb-8">Have a question? We'd love to hear from you.</p>

        <div className="card">
          <form onSubmit={handleSubmit} className="space-y-6">
            <input
              type="text"
              tabIndex="-1"
              autoComplete="off"
              value={formData.website}
              onChange={(e) => updateField("website", e.target.value)}
              className="hidden"
              aria-hidden="true"
            />

            <div>
              <label className="block text-sm font-medium text-gray-300 mb-2">Name</label>
              <input type="text" value={formData.name} onChange={(e) => updateField("name", e.target.value)} className="input-field w-full" required />
            </div>

            <div>
              <label className="block text-sm font-medium text-gray-300 mb-2">Email</label>
              <input type="email" value={formData.email} onChange={(e) => updateField("email", e.target.value)} className="input-field w-full" required />
            </div>

            <div>
              <label className="block text-sm font-medium text-gray-300 mb-2">Subject</label>
              <input type="text" value={formData.subject} onChange={(e) => updateField("subject", e.target.value)} className="input-field w-full" required />
            </div>

            <div>
              <label className="block text-sm font-medium text-gray-300 mb-2">Message</label>
              <textarea value={formData.message} onChange={(e) => updateField("message", e.target.value)} className="input-field w-full h-32" required />
            </div>

            <button type="submit" className="btn-primary w-full" disabled={loading}>
              {loading ? "Sending..." : "Send Message"}
            </button>
          </form>
        </div>
      </motion.div>
    </div>
  );
};

export default Contact;
